export default __webpack_public_path__ + "static/media/flourishing_orange_petal.11302a82.svg";